import { createStore } from "vuex";
import Web3 from "web3";
import { serialize } from "@/utils/common_method";

import dialog from "./modules/dialog";
import baseInfo from "./modules/baseInfo";

const savedAddress = localStorage.getItem("address");
const savedBalance = localStorage.getItem("balance");
const saveToken = localStorage.getItem("token");
const saveUserInfo = localStorage.getItem("userInfo");
const saveParentCode = localStorage.getItem("parentCode");
export default createStore({
  modules: {
    dialog,
    baseInfo,
  },
  state: {
    web3: null,
    address: savedAddress ? JSON.parse(savedAddress) : null,
    balance: savedBalance ? JSON.parse(savedBalance) : null,
    token: saveToken || null,
    userInfo: saveUserInfo ? JSON.parse(saveUserInfo) : null,
    isConnected: false,
    isLoading: false,
    referredBy: null,
    invitedUsersCount: 0,
    // Add state for BGM player
    audioFiles: [
      require("../assets/Audio/Ancestral Spirits.mp3"),
      require("../assets/Audio/Jahzza-TheLake.mp3"),
      require("../assets/Audio/A Long Walk.mp3"),

      // ...other mp3s
    ],
    currentSongIndex: 0,
    isPlaying: false,
    activityKey: "",
    parentCode: saveParentCode || "",
  },
  mutations: {
    setParentCode(state, parentCode) {
      state.parentCode = parentCode;
      localStorage.setItem("parentCode", parentCode);
    },

    removeParentCode(state) {
      state.parentCode = "";
      localStorage.removeItem("parentCode");
    },

    setActivityKey(state, activityKey) {
      state.activityKey = activityKey;
    },
    setAddress(state, newAddress) {
      state.address = newAddress;
      localStorage.setItem("address", JSON.stringify(newAddress));
    },
    setBalance(state, newBalance) {
      state.balance = newBalance;
      localStorage.setItem("balance", serialize(newBalance));
    },
    clearAddress(state) {
      state.address = null;
      localStorage.removeItem("address");
    },
    clearBalance(state) {
      state.balance = null;
      localStorage.removeItem("balance");
    },

    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },

    removeToken(state) {
      state.token = null;
      localStorage.removeItem("token");
    },

    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },

    removeUserInfo(state) {
      state.userInfo = null;
      localStorage.removeItem("userInfo");
    },

    setWeb3(state, web3) {
      state.web3 = web3;
    },
    setConnected(state, isConnected) {
      state.isConnected = isConnected;
    },
    // Add mutations for BGM player
    setPlayingState(state, playing) {
      state.isPlaying = playing;
    },
    setCurrentSongIndex(state, index) {
      state.currentSongIndex = index;
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setUsername(state, username) {
      state.userInfo.username = username;
    },
    setEmailA(state, email) {
      state.userInfo.EmailA = email;
    },
    setMyWords(state, mywords) {
      state.userInfo.mywords = mywords;
    },
    setAvatar(state, avatar) {
      state.userInfo.avatar = avatar;
    },
    SET_REFERRED_BY(state, referredBy) {
      console.log("Setting referral code in mutations:", referredBy);
      state.referredBy = referredBy;
    },
    updateInvitedUsersCount(state, count) {
      state.invitedUsersCount = count;
    },
  },
  actions: {
    async connectWallet({ commit }) {
      if (typeof window.ethereum !== "undefined") {
        const provider = window.ethereum;
        const web3 = new Web3(provider);
        commit("setWeb3", web3);

        try {
          const accounts = await provider.request({
            method: "eth_requestAccounts",
          });

          commit("setAddress", accounts[0]);
          commit("setConnected", true);

          const balance = await web3.eth.getBalance(accounts[0]);
          commit("setBalance", balance);
        } catch (error) {
          if (process.env.NODE_ENV === "development") {
            console.error("Error connecting wallet:", error);
          }
        }
      } else {
        console.log("No web3 provider detected. Please install MetaMask.");
      }
    },
    async getBalance({ state }) {
      if (!state.isConnected || !state.address) {
        return null;
      }

      try {
        const web3 = state.web3;
        const balance = await web3.eth.getBalance(state.address);
        return balance;
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("Error getting balance:", error);
        }
        return null;
      }
    },
    async loadBalanceFromLocalStorage({ commit }) {
      const savedBalance = localStorage.getItem("balance");
      if (savedBalance) {
        commit("setBalance", JSON.parse(savedBalance));
      }
    },

    handleReferral({ commit }, referredBy) {
      console.log("Handling referral code:", referredBy);
      // 确保调用的 mutation 名称与定义的名称匹配
      commit("SET_REFERRED_BY", referredBy);
    },
  },
});
